import * as yup from 'yup';

export const finalizePoliciesSchema = yup.object({
  policies: yup.array(yup.string()).min(1).required(),
});
